export default __webpack_public_path__ + "static/media/speraxlogo_black.6e29899c.svg";